import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import {
  Modal,
  Button,
  Grid,
  Axios,
  List,
  Icon,
  notice,
  Segment,
} from 'component/base'
import { Custom } from 'component/pieces'

export const GyomuMaeTenkoKirokuModal = props => {
  const {
    isOpenModal,
    onClickCancel,
    kumiaiin_id,
    id,
    gyomuMaeId,
  } = props

  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)

  const BASE_PATH = `/api/staff/kumiaiin/${kumiaiin_id}/tenko_kiroku/${id}/gyomu_mae_tenko_kiroku/${gyomuMaeId}`

  useEffect(() => {
    if(isOpenModal){
      callGetApi()
    }
  }, [isOpenModal])

  const callGetApi = async () => {
    setLoading(true)
    const { data, error } = await Axios.ajax.get(`${BASE_PATH}`)
    if (error){
      notice({
        title: 'Error',
        description: '業務前点呼記録データの取得に失敗しました',
        type: 'error',
      })
      setLoading(false)
      return
    }
    setLoading(false)
    setData(data)
  }

  return (
    <>
      <Modal
        closeIcon={<Icon name='close' circular size='large' />}
        closeOnEscape={true}
        closeOnDimmerClick={true}
        onClose={onClickCancel}
        open={isOpenModal}
      >
        <Modal.Header>業務前点呼記録</Modal.Header>
        <Segment loading={loading}>
        <Modal.Content>
            <Custom.Divider.Segment content='点呼記録' />
                <Custom.Modal.TenkoKiroku data={data} />
            <Custom.Divider.Segment content='業務前点呼記録'/>
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <List divided relaxed>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>実施時刻</List.Header>
                                {`${data.time}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>点呼方法</List.Header>
                                {`${data.tenko_type_kbn === 'taimen' ? '対面' : 'その他'}`}
                                </List.Content>
                            </List.Item>
                            {data.tenko_type_sonota && (
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>点呼方法（その他）</List.Header>
                                {`${data.tenko_type_sonota}`}
                                </List.Content>
                            </List.Item>
                            )}
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>点呼執行者</List.Header>
                                {`${data.tenko_shikkosha}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>アルコール検知器の使用の有無</List.Header>
                                {`${data.is_alcohol_check === true ? '有' : '無'}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>酒気帯びの有無</List.Header>
                                {`${data.is_shuki_obi === true ? '有' : '無'}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>健康状況</List.Header>
                                {`${data.kenko_jotai_kbn === 'good' ? '良好' : '不調'}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>ブレーキペダルの状況（踏みしろ・きき具合）</List.Header>
                                {`${data.brake_pedal_jokyo_kbn === 'ok' ? '点検済み（正常）' : '点検済み（異常）'}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>パーキングブレーキの状況（引きしろ）</List.Header>
                                {`${data.parking_brake_jokyo_kbn === 'ok' ? '点検済み（正常）' : '点検済み（異常）'}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>エンジンの状況（かかり具合・異音）</List.Header>
                                {`${data.engine_jokyo_kbn === 'ok' ? '点検済み（正常）' : '点検済み（異常）'}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>灯火装置・方向指示器の状況（点灯・点滅具合等）</List.Header>
                                {`${data.toka_shijiki_jokyo_kbn === 'ok' ? '点検済み（正常）' : '点検済み（異常）'}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>エンジンオイル・ブレーキオイル・リザーバータンクの状況</List.Header>
                                {`${data.oil_tank_jokyo_kbn === 'ok' ? '点検済み（正常）' : '点検済み（異常）'}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>タイヤの状況（空気圧・亀裂や損傷・摩耗・取付状態）</List.Header>
                                {`${data.tire_jokyo_kbn === 'ok' ? '点検済み（正常）' : '点検済み（異常）'}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content style={{ whiteSpace: 'pre-line' }}>
                                <List.Header style={{ marginBottom: '0.3em' }}>（点検異常時）詳細・異常箇所の措置</List.Header>
                                {data.sochi ? data.sochi : <span style={{ visibility: 'hidden' }}>　</span>}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>アルコールチェックの検査値</List.Header>
                                {`${data.alcohol_check_value}`} mg/L
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>走行距離計（運行前）</List.Header>
                                {`${data.unko_mae_soko_kyori}`} km
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content style={{ whiteSpace: 'pre-line' }}>
                                <List.Header style={{ marginBottom: '0.3em' }}>その他必要な指示事項（天候等）</List.Header>
                                {data.sonota ? data.sonota : <span style={{ visibility: 'hidden' }}>　</span>}
                                </List.Content>
                            </List.Item>
                        </List>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Modal.Content>
        </Segment>
        <Modal.Actions>         
          <Button onClick={onClickCancel} content='閉じる' />
        </Modal.Actions>
      </Modal>
    </>
  )
}